/* eslint-disable no-console */
import React from 'react';
import { message, Modal } from 'antd';
const { confirm } = Modal;
import { parseUrl } from '../utils';
import { getOnline } from '../api/request';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const editUrlAddNeed = (url) => {
    const { projectId, teamType, sourcesType, sourcesId } = parseUrl();
    let resUrl = url;
    // 新类型拼接参数
    if (projectId) {
        resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}projectId=${projectId}`;
    }
    if (teamType) {
        resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}teamType=${teamType}`;
    }
    if (sourcesType) {
        resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}sourcesType=${sourcesType}`;
    }
    if (sourcesId) {
        resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}sourcesId=${sourcesId}`;
    }
    return resUrl;
};

export const goSubscribeList = (serviceTeamId) => {
    const { evaluationReportId, service_name, saas_id } = parseUrl();
    if (evaluationReportId) {
        window.open(editUrlAddNeed(`/tutor/subscribe/${serviceTeamId}?service_name=${service_name}&evaluationReportId=${evaluationReportId}&saas_id=${saas_id}`));
        return;
    }
    window.open(editUrlAddNeed(`/tutor/subscribe/${serviceTeamId}?service_name=${service_name}`));
};

// statue 状态  bookingOnlineNum 最大上限数
const showConfirm = (statue, bookingOnlineNum, serviceTeamId) => {
    confirm({
        title: '私教预约服务提示',
        icon: <ExclamationCircleOutlined />,
        content: statue === 1 ? `当前您还有${bookingOnlineNum}节未完成的私教课，请先完成至少一节课后再进行预约！请勿屯课哦~` : '您已预约私教测评课程，请课程结束后再次预约',
        okText: '确定',
        cancelText: '查看记录',
        onCancel() {
            goSubscribeList(serviceTeamId);
        },
    });
};

// 校验手持数量是否可预约 serviceTeamId团队id
export const ifRestrict = async (serviceTeamId) => {
    const { evaluationReportId, saas_id, chapterId, sectionId, sourcesType } = parseUrl();
    const { data } = await getOnline(
        {
            serviceTeamId: serviceTeamId,
            sourcesType: sourcesType ? sourcesType : evaluationReportId ? 1 : 0,
            courseId: evaluationReportId ? saas_id : undefined,
            chapterId: evaluationReportId ? chapterId : undefined,
            sectionId: evaluationReportId ? sectionId : undefined
        }
    );
    return new Promise((resolve) => {
        try {
            if (data.status === 0) {
                if (data.result.statue !== 0) {
                    showConfirm(data.result.statue, data.result.bookingOnlineNum, serviceTeamId);
                }
            } else {
                message.warning(data.message);
            }
            resolve(data.result.statue);
        } catch (e) {
            console.log(e);
        }
    });
};
